import React, { useEffect } from "react";
import PaymentDashboardRoutes from "./PaymentDashboardRoutes";
import { isErrorPage } from "../../../Contracts/Routes";
import { useUserStore } from "../../../Store/User";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import { useAxiosInterceptor } from "../../../Utils/AxiosInterceptorUtils";

const PaymentAppDashboard: React.FC = () => {
  const { getCurrentUser } = useUserStore();
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  useAxiosInterceptor();

  useEffect(() => {
    if (isAuthenticated && !isLoading && !isErrorPage(location.pathname)) {
      getCurrentUser(getAccessTokenSilently);
    }
  }, [isAuthenticated, isLoading, getCurrentUser, getAccessTokenSilently, location.pathname]);
  return (
    <>
      <PaymentDashboardRoutes />
    </>
  );
};

export default PaymentAppDashboard;
